// extracted by mini-css-extract-plugin
export default {"zoomModal":"s0-z","image":"t0-z","button":"u0-z","isOverlayShown":"v0-z"};